import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/CustomModal";
import { useEffect } from "react";
import { HsCodeController } from "@/app/core/base/controllers/HsCodeController";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";

export default function HsCodeModal({ show, onHide }) {
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState([]);
    const [query, setQuery] = useState("");

    useEffect(() => {
        if (show) {
            loadCodes();
        }
    }, [show])

    function save() {
    }
    function loadCodes() {
        HsCodeController.List(res => setData(res) | setFilter(res));
    }

    function handleChange(value) {
        setQuery(value);
        let docs_to_show = [];

        if (value.length > 0) {
            setFilter([]);
            docs_to_show = autocomplete(value);
            setFilter(docs_to_show);
        } else {
            docs_to_show = [];
            setFilter([]);
        }
    }


    function autocomplete(value) {
        const inputValue = value.trim().toLowerCase();
        let itens = data;

        let newResults = [];

        for (let s in itens) {
            const item = itens[s];
            const name = item.name.toLowerCase();
            const hscode = item.hscode.toLowerCase();
            if (name.includes(inputValue) || hscode.includes(inputValue)) {
                newResults.push(item);
            }
        }

        return newResults;
    }

    return (
        <Modal
            title="HS Code"
            show={show}
            onHide={onHide}
            onSubmit={() => save()}>
            <div className="block-content">
                <div className="block block-fx-pop block-bordered border-info">
                    <div className="block-header">
                        <div className="block-title">
                            <i className="si si-question text-info mr-2" /> O HS Code é um código internacional para classificação e identificação de grupos de produtos perante as alfândegas dos países
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <div className="input-group">
                        <input
                            type="text"
                            placeholder="Filtrar"
                            className="form-control"
                            id="search-filter"
                            value={query}
                            onChange={(evt) => handleChange(evt.target.value)} />
                        <div className="input-group-append">
                            <span
                                className="input-group-text"
                                onClick={() => setQuery("") | setFilter([])}
                                title="Limpar campo"
                            >
                                <i className="si si-close"></i>
                            </span>
                        </div>
                    </div>
                </div>

                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>{Translate(Message.Name)}</th>
                        </tr>
                    </thead>
                    {query && query.length > 0 ? (
                        <tbody>
                            {filter &&
                                filter.map((item) => (
                                    <tr>
                                        <td>{item.hscode}</td>
                                        <td>{item.name}</td>
                                    </tr>
                                ))}
                        </tbody>
                    ) : (
                        <tbody>
                            {data &&
                                data.map((item) => (
                                    <tr>
                                        <td>{item.hscode}</td>
                                        <td>{item.name}</td>
                                    </tr>
                                ))}
                        </tbody>
                    )}
                </table>
            </div>
        </Modal>
    );
}
